<template>
  <div
    v-if="(typeof value === 'string' && value.toLowerCase()) === '::restrict::'"
    class="restrict-chip text-caption d-flex align-center"
    :title="$t('info_restrita_usuario')"
  >
    <v-card
      rounded
      color="transparent"
      elevation="0"
      style="padding: 0.01rem 0.2rem 0.01rem 0"
    >
      <v-icon size="10px" color="grey darken-0" class="mr-1">mdi-lock</v-icon>
      <span
        style="font-size: 11px"
        class="grey--text text--darken-0 font-italic"
        >{{ $t("restrito") }}</span
      >
    </v-card>
  </div>
  <span v-else>
    <slot />
  </span>
</template>

<script>
export default {
  props: ["value"],
};
</script>
